import { render } from "./fornecedorView.vue?vue&type=template&id=1d8bfd24"
import script from "./fornecedorView.vue?vue&type=script&lang=js"
export * from "./fornecedorView.vue?vue&type=script&lang=js"

import "./fornecedorView.vue?vue&type=style&index=0&id=1d8bfd24&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__